import { Component, Input } from '@angular/core';

export type Variant = 'error' | 'warning' | 'info' | 'light';

export type Size = 'normal' | 'condensed';

@Component({
  selector: 'gymfinder-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false,
})
export class AlertComponent {
  @Input()
  variant: Variant = 'info';

  @Input()
  size: Size = 'normal';

  public get icon(): string {
    switch (this.variant) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'notifications';
    }
  }
}
